// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3r4QL","checkboxCol":"Table_checkboxCol__2Fcke","emailCol":"Table_emailCol__13Y38","actionCol":"Table_actionCol__2KLVg"};